import React from 'react';
import { List } from 'antd';
import styled from 'styled-components';
import DocumentsListItem from './DocumentsListItem';

const DocumentsList = ({ documents, loading }) => (
  <DocumentsListContainer
    dataSource={documents}
    locale={{
      emptyText:
        loading
        ? 'Carregando documentos...'
        : 'Este processo não possui documentos capturados para colaboração'
    }}
    renderItem={documentObject =>
      <DocumentsListItem document={documentObject} />
    }
    />
)

const DocumentsListContainer = styled(List)`
  .ant-spin-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
  }
`

export default DocumentsList;



// WEBPACK FOOTER //
// ./src/components/DocumentsList/index.js